import { combineReducers } from "redux"
import GlobalReducer from "./Global/GlobalReducer"

export default combineReducers({
    GlobalReducer
})
